<div
  class="w-[375px] h-min-[180px] relative rounded-[20px] border bg-white pb-[22px] pt-[13px] shadow-[0px_5px_20px_0px_rgba(0,0,0,0.20)]">
  <!--  card body-->
  <div class="pl-[24px] pr-[12px]">
    <div class="flex items-start gap-x-[11.36px]">
      <button (click)="navigateToProductDetails()" class="flex h-[112px] w-[81.6px]">
        <ln-ln-image-frame
          [src]="product.producto.activosDigitales[0].urlImg"
          alt="Imagen del producto"
          class="h-[112px] w-[81.6px] rounded-lg"></ln-ln-image-frame>
      </button>
      <div class="w-full">
        <button (click)="navigateToProductDetails()" class="flex flex-row items-start justify-start">
        <div class="w-full text-start line-clamp-2 overflow-hidden text-ellipsis break-words text-base font-semibold text-cafe">{{product.producto.productoPrincipal.nombre}}</div>
        </button>
          @if (singlePiece) {
          <div class="justify-center text-naranja text-sm font-normal font-['Roboto'] leading-none">{{'messages.availabilityWillBeEvaluated' | transloco}}</div>
        }
        <div class="flex flex-col">
          <section>
            <div [ngClass]="[singlePiece ? 'justify-end pr-[58px] mt-[8px]': 'items-center gap-x-[13px] mt-[16px]', 'flex']">
<!--            <div class="mt-[26px] grid grid-cols-2 gap-x-[12.65px]">-->
              @if (!singlePiece) {
              <div class="gap-x-[4px]">
                @if(product.producto.precioOferta | number:'1.0-0') {
                  <div class="text-end text-base font-bold text-cafe">
                    $ {{ product.producto.precioOferta | number:'1.0-0' }} <span class="text-xs font-bold">USD</span>
                  </div>
                  <div class="text-sm font-normal text-verde">
                    <span class="line-through"> $ {{ product.producto.precio | number:'1.0-0'}}</span> <span class="text-xs"> USD</span>
                  </div>
                } @else {
                  <div class="text-end text-base font-bold text-cafe">
                    $ {{ product.producto.precio | number:'1.0-0'}} <span class="text-xs font-bold">USD</span>
                  </div>
                }
              </div>
              }
              <div>
                <div class=" text-sm font-normal text-cafe">{{'labels.count' | transloco}}: {{product.cantidad}}</div>
                <button (click)="navigateToShoppingCart()" class=" justify-start text-verde text-sm font-normal underline">{{'buttons.modifyCart' | transloco}}</button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>

    <div class="mt-[18px] justify-start text-xs font-normal text-cafe">
      {{'labels.exchangeAndReturnPolicyOf' | transloco}}<span class="font-medium"> {{'labels.lunaNuevaHome' | transloco}}</span>
    </div>
  </div>
</div>

